// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClusterOutlinedSvg from "@fishx/icons-svg/es/asn/ClusterOutlined";
import FishxIcon from '../components/FishxIcon';

var ClusterOutlined = function ClusterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClusterOutlinedSvg
  }));
};

ClusterOutlined.displayName = 'ClusterOutlined';
export default React.forwardRef(ClusterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ClusterOutlined.js
// module id = 2259
// module chunks = 0